export const objFromArray = (arr: any[], key = "id"): Record<string, any> =>
  arr.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {} as Record<string, any>);

export const objFromArray_id = (arr: any[], key = "_id"): Record<string, any> =>
  arr.reduce((accumulator, current) => {
    accumulator[current[key]] = current;
    return accumulator;
  }, {} as Record<string, any>);
